
import TabArticles from '../TabArticles';
import SeoUtil from '../SeoUtil';


const SecurityTab = () => {
  const tab_title = 'Novinky zo sveta IT bezpečnosti'
  const url_category = 'security'

  return (<>
    <SeoUtil
      title={`Mudrosti Sveta | ${tab_title}`}
      description={tab_title}
      name='Mudrosti Sveta'
      type='articles' />
    <TabArticles tab_title={tab_title} url_category={url_category} />
  </>
  );
};

export default SecurityTab;